import { EnumResponse } from '@/api/services/common.dto'

export enum ShipmentEntityTypeEnum {
    SAMPLE = 'SAMPLE',
    PORTION = 'PORTION',
    SUBPORTION = 'SUBPORTION'
}
export interface ShipmentEntityTypeEnumResponse extends EnumResponse {
    code: ShipmentEntityTypeEnum
}

export enum ShipmentRequestStatusTypeEnum {
    AWAITING_SHIPMENT = 'AWAITING_SHIPMENT',
    IN_SHIPMENT = 'IN_SHIPMENT',
    SHIPMENT_FINISHED = 'SHIPMENT_FINISHED'
}
export interface ShipmentRequestStatusEnumResponse extends EnumResponse {
    code: ShipmentRequestStatusTypeEnum
}

export enum ShipmentItemStatusTypeEnum {
    SENT = 'SENT',
    RECEIVED = 'RECEIVED',
    NOT_RECEIVED = 'NOT_RECEIVED'
}
export interface ShipmentItemStatusEnumResponse extends EnumResponse {
    code: ShipmentItemStatusTypeEnum
}
